import axios from "axios"
import qs from "qs"
import { MessageBox } from "element-ui"
import eventBus from '../eventBus/eventBus.js'
//引入通用域名
import { COMMON_URL } from '../assets/js/const.js'

let ingnoreRoute = 'account'; // 跳转至登录页时忽略路由为account的页面
let ajaxTimes = 0; //重试请求计数

//将饿了么MessageBox改为异步任务
let messageAlert = function(msg) {
    return new Promise(function(resolve, reject) {
        MessageBox.alert(msg, '提示', {
            callback: action => {
                if (action == 'confirm') {
                    resolve(action);
                } else {
                    reject(action);
                }
                eventBus.$emit("loading", { toggle: false })
            },
        });
    });
}

//处理详情的状态
//sid 与 token 失效 http状态为200 error_code = 401、403
let disposeErrorCode = async(response) => {
        //获取 error_code
        let errorCodeStatus = response.data.error_code;
        //如果error_code!==0 说明是错误请求
        if (errorCodeStatus !== 0) {
            //先做错误信息提示
            switch (errorCodeStatus) {
                case 403: // sid失效
                    localStorage.removeItem('sid');
                    //此处无break;
                case 401: // token 失效
                    if (location.pathname.includes(ingnoreRoute) == false) {
                        await messageAlert('用户登录失效，请重新登录');
                        location.href = '/account/login';
                    }else{
                        ajaxTimes++;
                        if (ajaxTimes <= 3){
                            let res = await getSid();
                            if(res) {
                                await axios(response.config).then((res)=>{
                                    response.data = res.data;
                                    response.status = res.status;
                                })
                            }
                        } else {
                            ajaxTimes = 0; //恢复默认计数
                            await messageAlert('服务器错误');
                            break;
                        }
                    }
                    break;
                default:
                    await messageAlert(response.data.error_msg);
            }

            return response;
        }
    };
    //请求sid方法
let getSid = function() {
    //返回 promise
    //有sid则resolve 无则重新请求sid
    return new Promise(function(resolve, reject) {
        let sid = localStorage.getItem('sid');
        if (!sid) {
            axios({
                method: "post",
                url: COMMON_URL + '/app/init',
            }).then(function(res) {
                localStorage.setItem('sid', res.data.sid);
                sid = res.data.sid;
                resolve(sid)
            }).catch(function () {
                console.log('sid出错');
            });
        } else {
            resolve(sid)
        }
    });
}

//请求拦截器
axios.interceptors.request.use(function(config) {
    // sid=验证用户唯一性 token=验证登录状态
    // 获取sid与token
    let sid = localStorage.getItem('sid');
    let token = localStorage.getItem('token');
    let header = { 'Content-Type': 'application/x-www-form-urlencoded' };
    let indexurl = config.url.indexOf('typelist?os_type')
    if(indexurl == -1){
        //token == null说明用户验证失败 如果不在登录页则跳转登录
        if (token == null && location.pathname.includes(ingnoreRoute) == false) {
            MessageBox.alert('用户登录失效，请重新登录', '提示', {
                callback: action => {
                    location.href = '/account/login';
                }
            })
        } else {
            //统一扩展请求头
            if (sid != null) {
                header['X-SID'] = sid;
            }
            if (token != null) {
                header['X-TOKEN'] = token;
            }
            Object.assign(config.headers, header)
            return config;
        }
    }else{
        Object.assign(config.headers, header)
        return config;
    }
}, function(error) {
    return Promise.reject(error);
});
//响应拦截器
axios.interceptors.response.use(async function(response) {
    //统一处理error_code
    await disposeErrorCode(response);
    return response;
}, async function(error) {
    //统一处理error_code
    await disposeErrorCode(error.response);
    // 统一关闭loading 动画
    eventBus.$emit("loading", { toggle: false })
    return Promise.reject(error);
});
//统一get
export async function axiosGet(url, data) {
    //首先验证sid
    let res = await getSid();
    if(!res) return;
        //序列化数据
    let postData = qs.stringify(data);
    let result;
    //获取返回promise
    result = axios({
        method: "get",
        url: COMMON_URL + url + "?" + postData,
    });
    return result;
}
export async function axiosGetsdk(url) {
    let result;
    //获取返回promise
    result = axios({
        method: "get",
        url: COMMON_URL + url,
    });
    return result;
}
//统一post
export async function axiosPost(url, data) {
    //首先验证sid
    let res = await getSid();
    if(!res) return;
        //序列化数据
    data = qs.stringify(data);
    let result;
    //获取返回promise
    result = axios({
        method: "post",
        data: data,
        url: COMMON_URL + url,
    });
    return result;
}



// WEBPACK FOOTER //
// ./src/axios/axios.js